import React, { useEffect, useMemo, useState } from 'react';
import BlockUi from 'react-block-ui';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { Button, Card, CardBody, CardHeader, PopoverBody, UncontrolledPopover, Badge, Row, Col, Input, Modal, ModalBody, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Label, Collapse } from 'reactstrap';
import { ErrorAlert } from "../../Base/ErrorAlert";
import { getHelpLink, getHotelLanguageCode, getStatus, getPaymentStatuses, getPaymentGateways } from "./ReferenceDataFunctions"
import { getAPI } from "../../Base/API";
import CustomSelect from "../../Base/Common/CustomSelect";
import EditorText, { RICH_TEXT_MAX_LENGTH, RichTextView } from "../../Base/EditorText";
import 'react-block-ui/style.css';
import { HandleHelp, HandleHelpClick } from '../../../Utils/EventGA';
import Chart from "react-google-charts";



export const StyledCard = ({ block, children, icon, title, help, error, id }) => (

    <Card className="shadow border-0 h-100">
        <ErrorAlert error={error} />
        <BlockUi tag="div" blocking={block}>
            <CardHeader className="bg-white border-bottom-host">
                {icon ? <i className={icon + ' mr-1'}></i> : ''} {title ? <FormattedMessage id={title} /> : ''}

                {help ? <div className="float-right">
                    <span id="mainpagehelp" className="btn-sm btn-link" onClick={() => HandleHelp(id)} style={{ fontSize: 'medium' }}>
                        <i className="text-secondary fa-solid fa-circle-question mt-1"/>
                    </span>
                    <UncontrolledPopover data-trigger="focus" placement="left" target="mainpagehelp">
                        <PopoverBody>
                            {help}
                            {getHelpLink(id) ?
                                <a className="float-right" href={getHelpLink(id)} target="_blank">
                                    <span onClick={_ => HandleHelpClick(id, getHelpLink(id))}>
                                        <FormattedMessage id="CommonUIComponents.MoreDetails" />
                                    </span>
                                </a>
                            : '' }
                        </PopoverBody>
                    </UncontrolledPopover>

                </div> : ''}

            </CardHeader>
            <CardBody>
                {children}
            </CardBody>
        </BlockUi>

    </Card>

);
export const BlankCard = ({ block, children, help, error, className, bodyClassName }) => (

    <Card className={className ? className : "shadow border-0 h-100"}>
        <ErrorAlert error={error} />
        <BlockUi tag="div" blocking={block}>

            <CardBody className={bodyClassName}>
                {children}
            </CardBody>
        </BlockUi>

    </Card>

);
export const EmptyCard = ({ block, children, error }) => (
    <Card className="border-0 h-100">
        <ErrorAlert error={error} />
        <BlockUi tag="div" blocking={block}>
            <CardBody>
                {children}
            </CardBody>
        </BlockUi>
    </Card>
);


export const SelectHotel = ({ icon, name, onChangeFunc, isMulti = false, required, value, placeholder = 'Hotel', isDisabled = false }) => {

    const [data, setData] = useState([]);
    const [block, setLoad] = useState(true);
    const [ setError] = useState('');

    useEffect(() => {


        getAPI(result => {
            const { data, error } = result;
            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                //setError(errorMessage);
                setLoad(false)
                return;
            }
            if (data) {
                let arr = [];
                data.response[0].hotels.map((el) => { return arr.push({ value: el.hotelId, label: el.name2 }) });

                setData(arr);
                setLoad(false);

            }
        }, '/api/Voucher/Hotel/v1/hotel');

      
    }, []);

    return (
        <BlockUi tag="div" blocking={block}>
            <CustomSelect icon={icon} options={data} isClearable isSearchable required={required} name={name} placeholder={placeholder} isMulti={isMulti} value={data ? data.filter(el => el.value === value) : null} onChange={onChangeFunc.bind(this)} isDisabled={isDisabled}/>
        </BlockUi>
    )
};


export const SelectVoucherType= ({ icon, name, onChangeFunc, isMulti = false, required, value, placeholder = 'Card' }) => {

    const [data, setData] = useState([]);
    const [block, setLoad] = useState(true);
    const [setError] = useState('');

    useEffect(() => {


        getAPI(result => {
            const { data, error } = result;
            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                //setError(errorMessage);
                setLoad(false)
                return;
            }
            if (data) {
                let arr = [];
                data.response.map((el) => { arr.push({ value: el.id, label: el.code }) })

                setData(arr);
                setLoad(false);

            }
        }, '/api/Voucher/V1/Config');


    }, []);

    return (
        <BlockUi tag="div" blocking={block}>
            <CustomSelect icon={icon} options={data} isClearable isSearchable required={required} name={name} placeholder={placeholder} isMulti={isMulti} value={data ? data.filter(el => el.value === value) : null} onChange={onChangeFunc.bind(this)} />
        </BlockUi>
    )
};

export const SelectCancellationReason = ({ name, onChangeFunc, value, placeholder, isDisabled, isClearable, required }) => {

    const [data, setData] = useState([]);
    const [block, setLoad] = useState(true);

    useEffect(() => {
        let isMounted = true;

        getAPI(result => {
            if (!isMounted) return;

            const { data, error } = result;
            if (error) {
                setLoad(false);
                return;
            }
            if (data) {
                const arr = (data.response || []).filter(el => el.active).map(el => ({ value: el.id, label: el.name }));
                setData(arr);
                setLoad(false);
            }
        }, '/api/Voucher/v1/Config/cancellationReasons?active=true');

        return () => { isMounted = false; };
    }, []);

    return (
        <BlockUi tag="div" blocking={block}>
            <CustomSelect
                name={name}
                options={data}
                isClearable={isClearable}
                isSearchable
                required={required}
                placeholder={placeholder}
                value={data.find(el => el.value === value) || null}
                onChange={onChangeFunc}
                isDisabled={isDisabled}
            />
        </BlockUi>
    );
};

export const statusOptions = [
        { value: true, label: <FormattedMessage id="generic.active" /> },
        { value: false, label: <FormattedMessage id="generic.inactive" /> }
    ]

export const ActiveInactiveStatusCombo = ({ name, onChangeFunc, required = true, value, placeholder, isDisabled, isClearable }) => {

    return (
        <CustomSelect
            placeholder={placeholder}
            options={statusOptions}
            onChange={onChangeFunc.bind(this, name)}
            required={required}
            value={statusOptions.find(el => el.value === value)}
            isDisabled={isDisabled}
            isSearchable
            isClearable={isClearable}
        />
    )
};

export const ActiveInactiveStatusBadge = ({ status }) => (
    <Badge color={status ? 'primary' : 'secondary'} className={(status ? 'p-1 px-2 shadow  pr-3' : ' p-1 px-2 shadow ')}>{status ? <FormattedMessage id="generic.active" /> : <FormattedMessage id="generic.inactive" />}</Badge>
);

export const CommonHelper = ({ help, id, placement = 'left' }) => {
    const helpLink = getHelpLink(id);

    return (
        <div className="float-right">
            <span id={id} className="btn-sm btn-link" onClick={() => HandleHelp(id)} style={{ fontSize: 'medium' }}>
                <i className="text-secondary fa-solid fa-circle-question mt-2 "></i>
            </span>
            <UncontrolledPopover data-trigger="focus" placement={placement} target={id}>
                <PopoverBody>
                    <div className="mb-1">
                        {help}
                    </div>
                    {helpLink ?
                        <a className="float-right" href={helpLink} target="_blank">
                            <span onClick={_ => HandleHelpClick(id, helpLink)}>
                                <FormattedMessage id="CommonUIComponents.MoreDetails" />
                            </span>
                        </a>
                    : ''}
                </PopoverBody>
            </UncontrolledPopover>
        </div>
    )
};

export const countries = [
    'PT',
    'GB',
    'FR',
    'DE',
    'ES'
];

export function getLanguageOptions() {
    const languageOptions = [
        {
            value: 'PT',
            label: <span> <span className="flag-icon flag-icon-pt px-2 mr-1" /> <FormattedMessage id="MultiLang.Portuguese" /></span>
        },
        {
            value: 'EN',
            label: <span> <span className="flag-icon flag-icon-gb px-2 mr-1" /> <FormattedMessage id="MultiLang.English" /></span>
        },
        {
            value: 'FR',
            label: <span> <span className="flag-icon flag-icon-fr px-2 mr-1" /> <FormattedMessage id="MultiLang.French" /></span>
        },
        {
            value: 'DE',
            label: <span> <span className="flag-icon flag-icon-de px-2 mr-1" /> <FormattedMessage id="MultiLang.German" /></span>
        },
        {
            value: 'ES',
            label: <span> <span className="flag-icon flag-icon-es px-2 mr-1" /> <FormattedMessage id="MultiLang.Spanish" /></span>
        }
    ];
    return languageOptions;
}

// Central ordering for multi-language UIs: hotel language first, remaining
// options in the base order. Kept outside getLanguageOptions() because
// getHotelLanguageCode() depends on it for validation and the PT fallback.
export function getOrderedLanguageOptions() {
    const hotelLang = getHotelLanguageCode();
    const languageOptions = getLanguageOptions();
    return [
        ...languageOptions.filter(option => option.value === hotelLang),
        ...languageOptions.filter(option => option.value !== hotelLang)
    ];
}

// Sorts items bound to a language in the getOrderedLanguageOptions() order; unknown languages go last
export function sortByHotelLanguage(list, getLanguageCode) {
    const order = getOrderedLanguageOptions().map(option => option.value);
    const rank = (item) => {
        const idx = order.indexOf((getLanguageCode(item) || '').toUpperCase());
        return idx < 0 ? order.length : idx;
    };
    return [...list].sort((a, b) => rank(a) - rank(b));
}

// Screens whose language state holds flag country codes ('GB', not 'EN') map
// the hotel language back to a country before ordering.
export function getHotelLanguageCountry() {
    const hotelLang = getHotelLanguageCode();
    const entry = getMultiLangEmpty().find(l => l.languageCode === hotelLang);
    return entry ? entry.language : countries[0];
}

export function getOrderedCountries() {
    const hotelCountry = getHotelLanguageCountry();
    return [
        ...countries.filter(country => country === hotelCountry),
        ...countries.filter(country => country !== hotelCountry)
    ];
}


export function getMultiLangEmpty() {
    const multiLangEmpty = [
        {
            languageCode: "PT",
            language: "PT",
            title: null,
            description: null
        },
        {
            languageCode: "EN",
            language: "GB",
            title: null,
            description: null
        },
        {
            languageCode: "FR",
            language: "FR",
            title: null,
            description: null
        },
        {
            languageCode: "DE",
            language: "DE",
            title: null,
            description: null
        },
        {
            languageCode: "ES",
            language: "ES",
            title: null,
            description: null
        }
    ];
    return multiLangEmpty;
}

export const MultiLangTextWithTitle = ({ textList, updateTitle, udpateDescription, hasShortDesc = false, titleFieldName = "title", titleMaxLength, plainDescription = false }) => {
    const [lang, setLang] = useState(getHotelLanguageCode());

    const toggle = l => {
        if (lang !== l) setLang(l);
    }

    const text = textList && textList.find(t => t.languageCode === lang);

    return (
        <MultiLang textList={textList} udpateTerms={udpateDescription} toggle={toggle} lang={lang}>
            <div className='py-2 px-3'>
                <Row className="mb-2">
                    <Col>
                        <Label className="font_size_xxs text-muted mb-1">
                            <FormattedMessage id="MultiLang.Title" />
                        </Label>
                        <FormattedMessage id="MultiLang.Title">
                            {
                                placeholder => <Input type="text" className="px-2" name={titleFieldName} id={titleFieldName} placeholder={placeholder} maxLength={titleMaxLength} value={text && text[titleFieldName] || ''}  onChange={e => updateTitle(e, lang)} />
                            }
                        </FormattedMessage>
                    </Col>
                </Row>
                {hasShortDesc ?
                    <Row className="mb-2">
                        <Col>
                            <Label className="font_size_xxs text-muted mb-1">
                                <FormattedMessage id="MultiLang.ShortDescription" />
                            </Label>
                            <FormattedMessage id="MultiLang.ShortDescription">
                                {
                                    placeholder => <Input className="px-2" type="text" placeholder={placeholder} maxLength="100" name="shortDescription" value={text && text.shortDescription ? text.shortDescription : ''}  onChange={(e) => udpateDescription(e, lang)} />
                                }
                            </FormattedMessage>
                        </Col>
                    </Row>
                : ''}   
                <Row className="mb-2">
                    <Col>
                        <Label className="font_size_xxs text-muted mb-1">
                            <FormattedMessage id="MultiLang.Description" />
                        </Label>
                        <FormattedMessage id="MultiLang.Description">
                            {
                                placeholder =>
                                    plainDescription
                                        ? <Input className="px-2" type="textarea" placeholder={placeholder} rows="4" maxLength="3500" name="description" value={text && text.description ? text.description : ''} onChange={(e) => udpateDescription(e, lang)} />
                                        : <EditorText
                                            key={lang}
                                            placeholder={placeholder}
                                            name="description"
                                            value={text && text.description ? text.description : ''}
                                            onChange={(e) => udpateDescription(e, lang)}
                                        />
                            }
                        </FormattedMessage>
                    </Col>
                </Row>
            </div>
        </MultiLang>
    );
};

export const MultiLangText = ({ textList, udpateTerms, maxLength = RICH_TEXT_MAX_LENGTH }) => {
    const [lang, setLang] = useState(getHotelLanguageCode());

    const toggle = l => {
        if (lang !== l) setLang(l);
    }

    const text = textList && textList.find(t => t.languageCode === lang);

    // Without udpateTerms this is a read-only display — the terms picker in the wizard shows one per
    // draggable card. Render the text instead of an editor: an editor per card would be wasteful, and
    // it would sit between the card and the drag it is meant to start.
    if (!udpateTerms) {
        return (
            <MultiLang textList={textList} toggle={toggle} lang={lang}>
                <div className="py-2 px-3">
                    <RichTextView value={text && text.description} />
                </div>
            </MultiLang>
        );
    }

    return (
        <MultiLang textList={textList} udpateTerms={udpateTerms} toggle={toggle} lang={lang}>
            <FormattedMessage id="MultiLang.Description" >
                {
                    placeholder =>
                        <EditorText
                            key={lang}
                            placeholder={placeholder}
                            name="description"
                            maxLength={maxLength}
                            value={text && text.description ? text.description : ''}
                            required
                            onChange={(e) => udpateTerms(e, lang)}
                        />
                }
            </FormattedMessage>
        </MultiLang>
    );
};

// Returns the languages whose subject value contains the {{CardAmount}} merge tag.
// Used by Step 1 (inline warning) and Step 8 (block-level alert) to flag when
// a non-monetary typology has {{CardAmount}} in the configured subject.
export function getCardAmountTagLanguages(subjectTranslations) {
    if (!subjectTranslations) return [];
    return Object.entries(subjectTranslations)
        .filter(([, v]) => (v || '').indexOf('{{CardAmount}}') !== -1)
        .map(([lang]) => lang);
}

export const SUBJECT_LANGUAGES = ['PT', 'EN', 'FR', 'DE', 'ES'];

// Per-language single-line subject editor with character counter, used in
// Step 8 of the Card Config Wizard (US #21543). The Input's maxLength enforces
// the hard cap in the browser; the counter is informational.
export const MultiLangSubject = ({ subjectTranslations, onChange, maxLength = 100, disabled = false, placeholder = '' }) => {
    const [lang, setLang] = useState(getHotelLanguageCode());

    const toggle = l => {
        if (lang !== l) setLang(l);
    };

    const value = (subjectTranslations && subjectTranslations[lang]) || '';

    return (
        <MultiLang toggle={toggle} lang={lang}>
            <div className="py-2 px-3">
                <Input
                    type="text"
                    value={value}
                    maxLength={maxLength}
                    disabled={disabled}
                    placeholder={placeholder}
                    onChange={e => onChange(lang, e.target.value)}
                />
                <div className="d-flex justify-content-end pt-1">
                    <span className="font_size_xxs text-muted">
                        {value.length}/{maxLength}
                    </span>
                </div>
            </div>
        </MultiLang>
    );
};

const MultiLang = ({ toggle, lang, children }) => {
    const orderedOptions = useMemo(() => getOrderedLanguageOptions(), []);

    return (
        <div className="border rounded overflow-hidden">
            <div className="d-flex bg-light border-bottom">
                {orderedOptions.map((option, key) =>
                    <div key={key} style={{ padding: '0.7rem 1.2rem', fontWeight: (lang === option.value ? 'bold' : '500') }}
                        className={`d-flex pointer align-items-center small ${lang === option.value ? ' bg-white border-bottom-host-bold ' : ' text-muted '}`} 
                        onClick={() => toggle(option.value)} 
                    >
                        {option.label}
                    </div>
                )}
            </div>
            <div className=" bg-white">
                {children}
            </div>
        </div>
    );
};

export function prettifyXml(sourceXml) {
    var xmlDoc = new DOMParser().parseFromString(sourceXml, 'application/xml');
    var xsltDoc = new DOMParser().parseFromString([
        // describes how we want to modify the XML - indent everything
        '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
        '  <xsl:strip-space elements="*"/>',
        '  <xsl:template match="para[content-style][not(text())]">', // change to just text() to strip space in text nodes
        '    <xsl:value-of select="normalize-space(.)"/>',
        '  </xsl:template>',
        '  <xsl:template match="node()|@*">',
        '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
        '  </xsl:template>',
        '  <xsl:output indent="yes"/>',
        '</xsl:stylesheet>',
    ].join('\n'), 'application/xml');

    var xsltProcessor = new XSLTProcessor();
    xsltProcessor.importStylesheet(xsltDoc);
    var resultDoc = xsltProcessor.transformToDocument(xmlDoc);
    var resultXml = new XMLSerializer().serializeToString(resultDoc);
    return resultXml;
};


export const processStatusValues = [
    'MessageProcessStatusIsPending',
    'MessageProcessStatusIsResolved'
];


export const paymentStatus = [
    {
        value: 'Payed',
        label: <FormattedMessage id="ReferenceDataFunctions.Payed" />,
        color: 'success'
    },
    {
        value: 'Requested',
        label: <FormattedMessage id="ReferenceDataFunctions.Requested" />,
        color: 'warning'
    },
    {
        value: 'Canceled',
        label: <FormattedMessage id="ReferenceDataFunctions.Canceled" />,
        color: 'danger'
    }
];

export const PaymentPositionStatus = ({ status }) => {
    var currentStatus = paymentStatus.find(s => s.value === status);

    return <Badge color={currentStatus ? currentStatus.color : 'danger'} className={'p-1 px-2 shadow'} style={{ color: 'white' }}>{currentStatus ? currentStatus.label : ''}</Badge>
};

// Badge for online payment (kind "payment") and voucher (kind "voucher") states; values outside the vocabulary are shown raw
export const StatusBadge = ({ kind, status }) => {
    const statuses = kind === 'voucher' ? getStatus(true) : getPaymentStatuses();
    const current = statuses.find(s => s.value === status);

    return (
        <Badge color={current ? current.color : 'dark'} className="p-2">
            {current ? current.label : (status || '-')}
        </Badge>
    );
};

// Payment gateway logo, with the name as alt text and tooltip; gateways without a logo are shown as text
export const PaymentGatewayLogo = ({ gateway }) => {
    if (!gateway) return '-';

    const current = getPaymentGateways().find(g => g.value === gateway);

    return current?.logo
        ? <img height="20" src={current.logo} alt={current.label} title={current.label} />
        : gateway;
};

export const CancelationModal = ({ isOpen, toggle, exitFunc}) => {

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalBody>
                <EmptyCard>
                    <Row className="mb-3">
                        <Col>
                            <h5>
                                <FormattedMessage id="generic.cancelOperationQuestion" />
                            </h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button className="btn btn-host btn-sm" onClick={toggle}>
                                <FormattedMessage id="generic.cancel" />
                            </Button>
                        </Col>
                        <Col className="text-right">
                            <Button className="btn btn-host btn-s" onClick={exitFunc}>
                                <FormattedMessage id="generic.exit" />
                            </Button>
                        </Col>
                    </Row>
                </EmptyCard>
            </ModalBody>
        </Modal>
    );
}


export const Crt = ({ text, value }) => {
    return <Card className="shadow h-100 py-2 px-3" body>
        <Row className="align-items-center">
            <Col>
                <div className="text-secondary mb-1">
                    {text}
                </div>
            </Col>
        </Row>
        <Row>
            <Col className="text-right">
                <b className="font-weight-bold text-secondary mb-1">
                    {value}
                </b>
            </Col>
        </Row>
    </Card>
}

export const CrtDashboards = ({ text, value }) => {
    return <Card className="shadow h-100 border-0" body>
        <Row className="align-items-center">
            <Col>
                <div className="text-xs font-weight-bold text-secondary text-uppercase  mb-1">
                    {text}
                </div>
            </Col>
        </Row>
        <Row>
            <Col className="text-right">
                <h3 className="font-weight-bold text-secondary mb-1">
                    {value}
                </h3>
            </Col>
        </Row>
    </Card>
}


export const ChartCard = ({ title, chartType, options, data, total, fullScreen, fullScreenFunction, height }) => {
    return (
        <Card body className="shadow border-0 h-100" >
            <Row>
                <Col className="text-xs font-weight-bold text-secondary text-uppercase mb-1">{title}</Col>
                {total ?
                    <Col className="text-xs font-weight-bold text-secondary text-right mb-1">{total}</Col>
                    : ''}
                {fullScreen ?
                    <Col className="text-right col-1">
                        <i onClick={fullScreenFunction} className="fa-solid fa-expand-arrows-alt"></i>
                    </Col>
                    : ''}
            </Row>
            <Row>
                {data && data.length > 0 ?
                    <Chart
                        chartType={chartType}
                        width="100%"
                        height={height ? height : '200px'}
                        data={data}
                        options={options}
                    />
                    : ''}
            </Row>
        </Card>
    )
}


export const FormatAmountNumber = ({ value, currency, avoidDecimals }) => {
    return <FormattedNumber
        value={value}
        maximumFractionDigits={avoidDecimals && value && value % 1 == 0 ? 0 : 2}
        style="currency"
        currency={currency || global.hotelCurrency || 'EUR'}
    />
}

export const formatAmountNumberString = (value, intl, currency, avoidDecimals) => {
    if (!value && value !== 0) return '';
    
    return intl.formatNumber(value, {
        style: 'currency',
        currency: currency || global.hotelCurrency || 'EUR',
        maximumFractionDigits: avoidDecimals && value && value % 1 === 0 ? 0 : 2
    });
}



export const KebabMenu = ({ editFunction, copyFunction, deleteFunction, extraFields, direction }) => (
    <UncontrolledDropdown direction={direction}>
        <DropdownToggle style={{ background: 'none', border: 'none', color: 'unset', padding: 'unset', width: '10px' }} onClick={(e) => e.stopPropagation()}>
            <i className="fa-solid fa-ellipsis-v" />
        </DropdownToggle>

        <DropdownMenu positionFixed={true}>
            {extraFields ?
                extraFields.map((field, key) =>
                    <DropdownItem key={key} onClick={field.function}>
                        <i className={field.icon} />
                        {field.noTranslation ?
                            field.textClass ?
                                <span className={field.textClass}>
                                    {field.text}
                                </span>
                                :
                                field.text
                            :
                            field.textClass ?
                                <span className={field.textClass}>
                                    <FormattedMessage id={field.text} />
                                </span>
                                :
                                <FormattedMessage id={field.text} />
                        }
                    </DropdownItem>
                )
                : ''}

            {editFunction ?
                <DropdownItem onClick={editFunction}>
                    <i className="fa-solid fa-pen-to-square mr-2" />
                    <FormattedMessage id="generic.Edit" />
                </DropdownItem>
                : ''}

            {copyFunction ?
                <DropdownItem onClick={copyFunction}>
                    <i className="fa-regular fa-clone mr-2" />
                    <FormattedMessage id="generic.Copy" />
                </DropdownItem>
                : ''}

            {deleteFunction ?
                <DropdownItem onClick={deleteFunction} style={{ color: '#A80C19' }}>
                    <i className="mr-2 fa-regular fa-trash-can" />
                    <FormattedMessage id="generic.Delete" />
                </DropdownItem>
                : ''}
        </DropdownMenu>
    </UncontrolledDropdown>
);

export const FilterButton = ({ totalFilters, children, btnId, requiredList }) => {
    const [isOpen, setIsOpen] = useState(false);

    //Para os campos que sejam obrigatórios dentro da collapse, para passarem pela validação do btn de submit
    useEffect(() => {
        if (!btnId) return;

        const submitButton = document.getElementById(btnId);

        if (submitButton) {
            submitButton.addEventListener("click", handleSubmit);

            return () => {
                submitButton.removeEventListener("click", handleSubmit);
            };
        }
    }, [btnId]);

    const handleSubmit = () => {
        if (requiredList && requiredList.length > 0) {
            requiredList.forEach(id => {
                const input = document.getElementById(id);
                if (input) {
                    const value = input.value;
                    if (!value) {
                        setIsOpen(true);
                    }
                }
            });
        }
    };

    return <>
        <Button className="btn-sm btn-filter position-relative" onClick={_ => setIsOpen(!isOpen)}>
            <i className="fas fa-filter" />

            {totalFilters ?
                <span style={{ position: 'absolute', top: '-10px', fontWeight: '800', border: '1px solid', right: '-14px', padding: '1px' }} className="badge-filter-count shadow">
                    {totalFilters}
                </span>
                : ''}
        </Button>


        <div className="floatingFilterCard" style={{ position: 'absolute', top: '17px', right: !global.isMobile ? '15px' : '-32px' }}>
            <Collapse isOpen={isOpen}>
                <div className="filterCard shadow text-left">
                    <h5 className="mb-3"><FormattedMessage id="generic.Filters" /></h5>
                    {children}
                </div>
            </Collapse>
        </div>
    </>
}